import { render } from "./Planilla.vue?vue&type=template&id=4f954fd0&scoped=true"
import script from "./Planilla.vue?vue&type=script&lang=js"
export * from "./Planilla.vue?vue&type=script&lang=js"

import "./Planilla.vue?vue&type=style&index=0&id=4f954fd0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f954fd0"]])

export default __exports__